module.exports = __webpack_public_path__ + "static/media/catalog-icon-delete.36d37efe.svg";